var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiRrFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,24a1,1,0,0,1-.6-.2l-4-3A1,1,0,0,1,9,20V14.38L1.984,6.487A3.9,3.9,0,0,1,4.9,0H19.1a3.9,3.9,0,0,1,2.913,6.488L15,14.38V23a1,1,0,0,1-1,1Zm-3-4.5L13,21V14a1,1,0,0,1,.253-.664l7.268-8.177A1.9,1.9,0,0,0,19.1,2H4.9A1.9,1.9,0,0,0,3.479,5.158l7.269,8.178A1,1,0,0,1,11,14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrFilter);
export default __webpack_public_path__ + "static/media/fi-rr-filter.4044d81a.svg";
export { ForwardRef as ReactComponent };